export const FIND_PSEUDONYMS_REQUEST = 'FIND_PSEUDONYMS_REQUEST';

export const findPseudonymsRequest = ({
     filter = [],
     sorting = { field: 'id', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_PSEUDONYMS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
    }
});
